












































import Vue from "vue";
import Component from "vue-class-component";
import LabelValue from "@/components/miscellaneous/LabelValue.vue";
import { Prop, Watch } from "vue-property-decorator";
import Group from "@/components/miscellaneous/Group.vue";
import InsertionRepository from "@/repositories/insertion/InsertionRepository";
import DownloadLink from "@/components/miscellaneous/DownloadLink.vue";
import _ from "lodash";

const components = {
    LabelValue,
    Group,
    DownloadLink,
};

interface Document {
    link: string;
    clientOriginalFileName: string;
    createdBy: {
        displayName: string;
    };
    createdAt: string;
    type: string;
}

interface Proof {
    status: string;
    document: Document;
}

interface InvoiceLine {
    invoice: Invoice;
}

interface Invoice {
    uuid: string;
    date: string;
    documents: Document[];
}

interface Insertion {
    uuid: string;
    proofs: Proof[];
    invoiceLines: InvoiceLine[];
}

interface InvoiceList {
    [uuid: string]: Invoice;
}

@Component({ components })

export default class DocumentsList extends Vue {
    @Prop() public insertionUuid!: string;
    private insertion: Insertion | null = null;
    private loadingDocuments: boolean = false;

    @Watch("insertionUuid") private changeInsertion() {
        this.fetchData();
    }

    private mounted(): void {
        this.fetchData();
    }

    private fetchData(): void {
        this.loadingDocuments = true;
        const params = {
            filters: { uuid: this.insertionUuid },
            fields: [
                "uuid",
                "proofs.uuid",
                "proofs.status",
                "proofs.document.link",
                "proofs.document.clientOriginalFileName",
                "proofs.document.createdBy.displayName",
                "proofs.document.createdAt",
                "proofs.document.type",
                "invoiceLines.invoice.uuid",
                "invoiceLines.invoice.date",
                "invoiceLines.invoice.documents.link",
                "invoiceLines.invoice.documents.clientOriginalFileName",
                "invoiceLines.invoice.documents.createdBy.displayName",
                "invoiceLines.invoice.documents.type",
            ],
        };

        InsertionRepository.get(params).then((data: object[]) => {
            if (data.length > 0) {
                this.insertion = data[0] as Insertion;
                this.loadingDocuments = false;
            }
        });
    }

    private get invoices(): InvoiceList {
        const invoices: InvoiceList = {};
        if (!this.insertion) {
            return invoices;
        }

        _.forEach(this.insertion.invoiceLines, (invoiceLine: InvoiceLine) => {
            if (invoiceLine.invoice) {
                invoices[invoiceLine.invoice.uuid] = invoiceLine.invoice;
            }
        });

        return invoices;
    }

    private get canShowDocuments(): boolean {
        return !!this.insertion &&
            (0 < this.insertion.proofs.length
                || _.some(this.invoices, (invoice: Invoice) => {
                    return 0 < invoice.documents.length;
                })
            );
    }
}
